<form class="st-modal" [class.st-modal--expanded]="productsArr.length > 2" [formGroup]="fgRefer" (ngSubmit)="save()">
  <app-generic-modal title="TransferStock" [saving]="saving" [saveDisabled]="fgRefer.invalid" (cancel)="onNoClick()">
    <div class="st-body">

      <!-- Origen → Destino: el label vive dentro del app-generic-select (mat-label),
           así cada columna es un solo bloque y la flecha queda centrada
           exactamente con el select, sin importar el ancho de pantalla. -->
      <div class="st-warehouses">
        <div class="st-wh-col">
          <app-generic-select formControlName="warehouseFromId" label="OriginWarehouse" [options]="warehouses"
            valueField="id"></app-generic-select>
        </div>

        <div class="st-arrow-col">
          <div class="st-arrow">→</div>
        </div>

        <div class="st-wh-col">
          <app-generic-select formControlName="warehouseToId" label="DestinationWarehouse" [options]="warehouses"
            valueField="id" [optionDisabled]="isSameAsOrigin"></app-generic-select>
        </div>
      </div>

      <!-- Descripción -->
      <div class="st-field">
        <app-generic-input formControlName="description" label="Description" variant="textarea" [rows]="2"
          placeholder="TransferReason"></app-generic-input>
      </div>

      <!-- Buscar productos -->
      <div class="st-field">
        <label class="st-label">{{ 'SearchProducts' | localize }}</label>
        <app-search-products [input]="'productInput'" [showSplitName]="true" [addQuantity]="false"
          [showStockQuantity]="false" (newData)="searchProductsFromComponent($event)"></app-search-products>
      </div>

      <!-- Estado vacío -->
      <div class="st-empty" *ngIf="productsArr.length == 0">
        {{ 'EmptyProducts' | localize }}
      </div>

      <!-- Lista de productos -->
      <div class="st-list" *ngIf="productsArr.length > 0" formArrayName="listProducts">
        <div class="st-list-head">
          <div class="st-col-product">{{ 'Products' | localize }}</div>
          <div class="st-col-qty">{{ 'Quantity' | localize }}</div>
          <div class="st-col-actions"></div>
        </div>

        <div class="st-rows">
          <div class="st-row" *ngFor="let item of productsArr.controls; let i = index" [formGroupName]="i">
            <div class="st-col-product">
              <div class="st-prod-name">{{ item.value.name }}</div>
              <div class="st-overstock" *ngIf="isOverStock(item)">
                ⚠ {{ 'ExceedsAvailableStock' | localize }} ({{ item.value.stock }})
              </div>
            </div>

            <div class="st-col-qty">
              <div class="st-stepper">
                <div class="st-step-btn" (click)="decQty(i)">–</div>
                <input type="number" formControlName="count" min="1" class="st-qty-input">
                <div class="st-step-btn" (click)="incQty(i)">+</div>
              </div>
            </div>

            <div class="st-col-actions">
              <span class="st-remove" (click)="deleteProduct(i)" matTooltip="{{ 'Delete' | localize }}"
                attr.aria-label="{{ 'Delete' | localize }}">🗑</span>
            </div>
          </div>
        </div>

        <!-- Misma grilla de columnas que el header/filas (Producto/Cantidad/Acciones),
             así el total queda exactamente debajo de "Cantidad", no pegado al borde. -->
        <div class="st-total">
          <div class="st-col-product">{{ 'Total' | localize }}</div>
          <div class="st-col-qty">{{ getTotal() }}</div>
          <div class="st-col-actions"></div>
        </div>
      </div>

    </div>
  </app-generic-modal>
</form>